import { render } from "./VideoStream.vue?vue&type=template&id=5620240c&scoped=true"
import script from "./VideoStream.vue?vue&type=script&lang=js"
export * from "./VideoStream.vue?vue&type=script&lang=js"

import "./VideoStream.vue?vue&type=style&index=0&id=5620240c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5620240c"]])

export default __exports__